import type { TResponseGetAccountsByCoaId } from "@/apis/odin/apiODIN";
import type { TCoAMappingsAccountDTO } from "./TCoAMappingsAccountDTO";

export const convertAccountsResponseToDTO = (
    accounts: TResponseGetAccountsByCoaId,
): TCoAMappingsAccountDTO[] => {
    const accountsSortedByDisplayOrderFromLowestToHighest = accounts.toSorted(
        (a, b) => a.displayOrder - b.displayOrder,
    );

    const dto = accountsSortedByDisplayOrderFromLowestToHighest.map(
        account => ({
            id: account.accountId,
            account: account.accountName,
            code: account.accountCode,
            subcategory: account.subcategory ?? null,
            type: account.accountType,
            section: account.section ?? null,
            mappedFrom: account.mappedFrom,
            includeInSummarizedDocument: ["income", "expense"].includes(
                account.accountType,
            ),
        }),
    );

    return dto;
};
